import React from 'react';
import { FormControlLabel, FormGroup, Switch, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'hooks';

const ToggleUnits = () => {
  const { convertUnits, setConvertUnits } = useSettings();
  const { t } = useTranslation();

  const onChange = (event) => {
    setConvertUnits(event.target.checked);
  };
  return (
    <FormGroup>
      <FormHelperText style={{ marginTop: 8 }}>{t('units')}</FormHelperText>
      <FormControlLabel
        style={{ minWidth: 125, marginLeft: 15 }}
        control={<Switch checked={convertUnits} size="small" onChange={onChange} name="units" />}
        label={convertUnits ? 'Imperial' : 'Metric'}
      />
    </FormGroup>
  );
};
ToggleUnits.propTypes = {};
ToggleUnits.defaultProps = {};
export default ToggleUnits;
